import styled from 'astroturf/react';
import _Choice from "PingAnswerStyles-Choice.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/user_tagging/styles/PingAnswerStyles.tsx?styleId=Choice";
import _ChoiceText from "PingAnswerStyles-ChoiceText.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/user_tagging/styles/PingAnswerStyles.tsx?styleId=ChoiceText";
import _OtherTextInput from "PingAnswerStyles-OtherTextInput.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/user_tagging/styles/PingAnswerStyles.tsx?styleId=OtherTextInput";
import _ChoiceSelector from "PingAnswerStyles-ChoiceSelector.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/user_tagging/styles/PingAnswerStyles.tsx?styleId=ChoiceSelector";


export const Choice = /*#__PURE__*/styled("div", null, {
  displayName: "Choice",
  styles: _Choice
});

export const ChoiceText = /*#__PURE__*/styled("div", null, {
  displayName: "ChoiceText",
  styles: _ChoiceText
});

export const OtherTextInput = /*#__PURE__*/styled("input", null, {
  displayName: "OtherTextInput",
  styles: _OtherTextInput
});

export const ChoiceSelector = /*#__PURE__*/styled("div", null, {
  displayName: "ChoiceSelector",
  styles: _ChoiceSelector
});
